export const OPT_OUT = 'OPT_OUT'
